import React from 'react';
import { browserHistory } from 'react-router';
import { createStyles, withStyles, WithStyles } from '@material-ui/core';

import MainTabs from 'components/MainTabs';

const styles = () =>
  createStyles({
    root: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    content: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    },
  });

const TABS = ['chat', 'appointments', 'files'];

interface MainProps extends WithStyles<typeof styles> {
  children: React.ReactNode;
  params: any;
}

const Main: React.FC<MainProps> = ({ children, classes, params: { page } }) => {
  const handleTabChange = (tabKey: string) => {
    browserHistory.push(`/main/${tabKey}`);
  };

  return (
    <div className={classes.root}>
      <MainTabs tabs={TABS} tab={page} onTabChange={handleTabChange} />
      <div className={classes.content}>{children}</div>
    </div>
  );
};

export default withStyles(styles)(Main);
